export const opacityVariants = {
  opacity: {
    0: 'opacity-0',
    5: 'opacity-5',
    10: 'opacity-10',
    15: 'opacity-15',
    20: 'opacity-20',
    25: 'opacity-25',
    30: 'opacity-30',
    35: 'opacity-35',
    40: 'opacity-40',
    45: 'opacity-45',
    50: 'opacity-50',
    55: 'opacity-55',
    60: 'opacity-60',
    65: 'opacity-65',
    70: 'opacity-70',
    75: 'opacity-75',
    80: 'opacity-80',
    85: 'opacity-85',
    90: 'opacity-90',
    95: 'opacity-95',
    100: 'opacity-100',
  },
  'opacity-sm': {
    0: 'sm:opacity-0',
    5: 'sm:opacity-5',
    10: 'sm:opacity-10',
    15: 'sm:opacity-15',
    20: 'sm:opacity-20',
    25: 'sm:opacity-25',
    30: 'sm:opacity-30',
    35: 'sm:opacity-35',
    40: 'sm:opacity-40',
    45: 'sm:opacity-45',
    50: 'sm:opacity-50',
    55: 'sm:opacity-55',
    60: 'sm:opacity-60',
    65: 'sm:opacity-65',
    70: 'sm:opacity-70',
    75: 'sm:opacity-75',
    80: 'sm:opacity-80',
    85: 'sm:opacity-85',
    90: 'sm:opacity-90',
    95: 'sm:opacity-95',
    100: 'sm:opacity-100',
  },
  'opacity-md': {
    0: 'md:opacity-0',
    5: 'md:opacity-5',
    10: 'md:opacity-10',
    15: 'md:opacity-15',
    20: 'md:opacity-20',
    25: 'md:opacity-25',
    30: 'md:opacity-30',
    35: 'md:opacity-35',
    40: 'md:opacity-40',
    45: 'md:opacity-45',
    50: 'md:opacity-50',
    55: 'md:opacity-55',
    60: 'md:opacity-60',
    65: 'md:opacity-65',
    70: 'md:opacity-70',
    75: 'md:opacity-75',
    80: 'md:opacity-80',
    85: 'md:opacity-85',
    90: 'md:opacity-90',
    95: 'md:opacity-95',
    100: 'md:opacity-100',
  },
  'opacity-lg': {
    0: 'lg:opacity-0',
    5: 'lg:opacity-5',
    10: 'lg:opacity-10',
    15: 'lg:opacity-15',
    20: 'lg:opacity-20',
    25: 'lg:opacity-25',
    30: 'lg:opacity-30',
    35: 'lg:opacity-35',
    40: 'lg:opacity-40',
    45: 'lg:opacity-45',
    50: 'lg:opacity-50',
    55: 'lg:opacity-55',
    60: 'lg:opacity-60',
    65: 'lg:opacity-65',
    70: 'lg:opacity-70',
    75: 'lg:opacity-75',
    80: 'lg:opacity-80',
    85: 'lg:opacity-85',
    90: 'lg:opacity-90',
    95: 'lg:opacity-95',
    100: 'lg:opacity-100',
  },
  'opacity-xl': {
    0: 'xl:opacity-0',
    5: 'xl:opacity-5',
    10: 'xl:opacity-10',
    15: 'xl:opacity-15',
    20: 'xl:opacity-20',
    25: 'xl:opacity-25',
    30: 'xl:opacity-30',
    35: 'xl:opacity-35',
    40: 'xl:opacity-40',
    45: 'xl:opacity-45',
    50: 'xl:opacity-50',
    55: 'xl:opacity-55',
    60: 'xl:opacity-60',
    65: 'xl:opacity-65',
    70: 'xl:opacity-70',
    75: 'xl:opacity-75',
    80: 'xl:opacity-80',
    85: 'xl:opacity-85',
    90: 'xl:opacity-90',
    95: 'xl:opacity-95',
    100: 'xl:opacity-100',
  },
}
